import React, { useEffect, useState } from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import Profile from "../../components/profile";
import { useCookies } from "react-cookie";
import Notification from "../../components/Notification";
import Trolly from "../../components/Trolly";
import "../../css/trolly.css";
import LoadingScreen from "../../components/LoadingScreen";
import Alert from "../../components/Alert";
import { useNavigate } from "react-router-dom";
import DeleteConfirm from "../../components/DeleteConfirm";

export default function TrollyPage() {
  const [isLoading, setIsLoading] = useState(false);
  const [alertActive, setAlertActive] = useState(true);
  const [alert, setAlert] = useState({});
  const [cookies, setCookie] = useCookies(["accessToken"]);
  const [wishlist, setWishlist] = useState([]);
  const [confirmActive, setConfirmActive] = useState(false);
  // const [loadingActive, setLoadingActive] = useState(false);
  const [productId, setproductId] = useState();
  const [user, setUser] = useState({})

  const navigate = useNavigate();

  const checkout = [];
  let amount = 0;
  let priceTotal = 0;
  // console.log(data);

  const activateAlert = () => {
    setAlertActive(true);
    setTimeout(() => {
      setAlertActive(false);
    }, 3000);
  };

  React.useEffect(() => {
    const handleGetWishlist = async () => {
      setIsLoading(true);
      try {
        const url = `https://w-shop-backend.vercel.app/api/wishlist`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + cookies.accessToken,
          },
        });
        const body = await response.json();
        if (body.status !== "success") {
          throw new Error(body.message);
        } else {
          setWishlist(body.data);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        setAlert({
          type: "danger",
          message: "Error: " + error.message,
        });
        activateAlert();
      }
    };
    handleGetWishlist()
  }, [cookies])

  const handleUpdateWishlist = async () => {
    setIsLoading(true);
    try {
      if (checkout.length < 1) {
        throw new Error('Pilih product sebelum checkout')
      }
      for (let index = 0; index < checkout.length; index++) {
        const url = `https://w-shop-backend.vercel.app/api/wishlist`;
        const response = await fetch(url, {
          method: 'PUT',
          headers: {
            'Content-type': 'application/json',
            'Authorization': 'Bearer ' + cookies.accessToken,
          },
          body: JSON.stringify({ id: checkout[index], status: 'checkout' }),
        });
        const body = await response.json();
        if (body.status !== 'success') {
          throw new Error(body.message,);
        }
      }
      setIsLoading(false)
      navigate('/checkout')
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: 'danger',
        message: 'Error: ' + error.message,
      })
      activateAlert();
    }
  }


  const handleDeleteWishlist = async (idProduct) => {
    setIsLoading(true);
    try {
      const url = `https://w-shop-backend.vercel.app/api/products/${idProduct}/wishlist`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + cookies.accessToken,
        },
      });
      const body = await response.json();
      if (body.status !== "success") {
        throw new Error(body.message);
      } else {
        const event = {
          type: "alert",
          alert: {
            type: "success",
            message: "Produk ditambahkan ke keranjang",
          },
        };
        setCookie("event", event, { path: "/" });
        setAlert(event.alert);
        activateAlert();
        handleHideConfirm();
        setTimeout(() => {
          window.location.reload();
        }, 100);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setAlert({
        type: "danger",
        message: "Error: " + error.message,
      });
      activateAlert();
    }
  };

  const handleShowConfirm = (idUser, idProduct) => {
    setConfirmActive(true);
    setproductId(idProduct);
  };

  const handleHideConfirm = () => {
    setConfirmActive(false);
  };

  const rupiah = (number) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
    }).format(number);
  };

  const [checkss, setCheckss] = useState([]);
  useEffect(() => {
    function validateCheckout() {
      wishlist.map((w) => (
        w.wishlist.status === 'checkout' ? (navigate('/checkout')) : (null)
      ))
    }
    validateCheckout()
    setCheckss(wishlist);
  }, [wishlist, navigate]);

  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === 'allSelect') {
      let tempUser = checkss.map((user) => {
        return { ...user, isChecked: checked }
      })
      setCheckss(tempUser)
    } else {
      let tempUser = checkss.map((user) => (
        user.wishlist.id === parseInt(name) ? { ...user, isChecked: checked } : user
      ));
      setCheckss(tempUser)
    }
  };
  checkss.map((user) => (
    user?.isChecked ? (
      amount += 1,
      priceTotal += (user.wishlist.amount * user.price),
      (checkout.push(user.wishlist.id))
    ) : amount
  ));

  return (
    <div>
      <LoadingScreen active={isLoading} />
      <Alert active={alertActive} type={alert.type} message={alert.message} />
      <DeleteConfirm
        active={confirmActive}
        message="Ingin menghapus produk ini dari keranjang ?"
        cancelHandler={handleHideConfirm}
        deleteHandler={() => {
          handleDeleteWishlist(productId);
        }}
      />
      <Navbar userData={setUser}
        logReg={<Profile userData={user}/>}
        notification={<Notification />}
        trolly={<Trolly />}
      />
      <div className="main">
        <div className="container py-5">
          <div className="d-none d-md-flex  pt-2 px-3 " style={{ backgroundColor: "white" }}>
            <div className="headerTrolly produk d-flex">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="allSelect"
                  checked={!checkss.some((user) => user?.isChecked !== true)}
                  onChange={handleChange}
                />
              </div>
              <p>Produk</p>
            </div>
            <div className="headerTrolly harsa">
              <p>Harga Satuan</p>
            </div>
            <div className="headerTrolly kuantitas">
              <p>Kuantitas</p>
            </div>
            <div className="headerTrolly tothar">
              <p>Total Harga</p>
            </div>
            <div className="headerTrolly aksi">
              <p>Aksi</p>
            </div>
          </div>
          <div style={{ minHeight: "300px" }}>
            {checkss.map((wish, index) => (
              <div
                key={index++}
                className="pt-2 px-3 my-3 mb-5"
                style={{ backgroundColor: "white" }}
              >
                <div className="d-flex border-bottom">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={wish.wishlist.id}
                      checked={wish?.isChecked || false}
                      onChange={handleChange}
                    />
                    <p>{wish.shop.shopName}</p>
                  </div>
                </div>
                <div className=" py-3 d-md-flex d-block">
                  <div className=" d-flex produk">
                    <img
                      alt=""
                      src={wish.imgUrl}
                      className=" ms-2"
                      width={118}
                      height={116}
                    />
                    <p className=" ms-2 py-3">{wish.product}</p>
                  </div>
                  <div className="harsa d-none d-md-flex py-3">
                    {rupiah(wish.price)}
                  </div>
                  <div className="kuantitas ms-4 ms-md-0 py-3">
                    {wish.wishlist.amount}
                  </div>
                  <div className="tothar tot ms-4 ms-md-0 py-3">
                    {rupiah(wish.wishlist.amount * wish.price)}
                  </div>
                  <div className="aksi mt-3">
                    <a href={`/search/detailSearch/${wish.id}`} className="text-info ms-4 ms-md-0 py-3 text-decoration-none me-3">Ubah</a>
                    <a href="#=" className="del ms-4 ms-md-0 py-3 text-danger" onClick={() => {
                      handleShowConfirm(wish.wishlist.userId, wish.id);
                    }}>
                      Hapus</a>
                  </div>
                </div>
                <div className="border-top px-4 py-2">
                  Pesan
                  <p className="mt-3 border-bottom text-secondary">{wish.wishlist.message}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="" style={{ paddingTop: 100 }}>
            <div
              className="pt-3 py-2 px-3 my-3 d-md-flex d-block align-items-end  justify-content-between mt-5"
              style={{ backgroundColor: "white", marginTop: "100000px" }}
            >
              <div className=" d-flex">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <p className="pilpro ms-2">Pilih Produk</p>
              </div>
              <p className="pilpro">Total {amount} Produk</p>
              <p className="hartopro">{rupiah(priceTotal)}</p>
              <button className="chckOut mb-3 ms-auto ms-md-0 d-block" onClick={() => (handleUpdateWishlist())}>
                Checkout
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
